<template>
	<div class="tip-container">
		<div>
			<h2 class="heading--info" tabindex="0">
				Tip the crew and send an Emoji?
			</h2>
		</div>
		<div class="tip-options">
			<div class="tip-card no-highlight" tabindex="0" aria-label="no tip" @click="closeModal()" @keydown.enter="closeModal()">
				<span>No tip</span>
			</div>
			<div class="tip-card no-highlight"
				tabindex="0" aria-label="ten percent tip"
				@keydown.enter="handleTipClick('small')"
				@click="handleTipClick('small')">
				<div class="tip-emoji">💙</div>
				<div v-if="abovePriceBoundary" class="tip--amount small-tip">10&percnt;</div>
				<div v-if="!abovePriceBoundary" class="tip--amount small-tip">{{ smallTip() }}</div>
				<div v-if="abovePriceBoundary" class="tip--actual-amount">{{ smallTip() }}</div>
			</div>
			<div class="tip-card no-highlight"
				tabindex="0" aria-label="fifteen percent tip"
				@keydown.enter="handleTipClick('medium')"
				@click="handleTipClick('medium')">
				<div class="tip-emoji">💕</div>
				<div v-if="abovePriceBoundary" class="tip--amount medium-tip">15&percnt;</div>
				<div v-if="!abovePriceBoundary" class="tip--amount medium-tip">{{ mediumTip() }}</div>
				<div v-if="abovePriceBoundary" class="tip--actual-amount">{{ mediumTip() }}</div>
			</div>
			<div class="tip-card no-highlight"
				tabindex="0" aria-label="twenty percent tip"
				@keydown.enter="handleTipClick('large')"
				@click="handleTipClick('large')">
				<div class="tip-emoji">😍</div>
				<div v-if="abovePriceBoundary" class="tip--amount large-tip">20&percnt;</div>
				<div v-if="!abovePriceBoundary" class="tip--amount large-tip">{{ largeTip() }}</div>
				<div v-if="abovePriceBoundary" class="tip--actual-amount">{{ largeTip() }}</div>
			</div>
		</div>
		<!-- TODO custom tip -->
	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import { CART } from '@/stores/defs';
	import Formatter from '@/utils/Formatter';

	const priceBoundary = 1500;

	export default {
		props: {
			price: {
				type: Number,
				default: priceBoundary,
			},
		},
		data() {
			return {
				tips: {
					small: 100,
					medium: 200,
					large: 300,
				}
			}
		},
		computed: {
			abovePriceBoundary() {
				return this.price > priceBoundary;
			},
		},
		methods: {
			...mapActions({
				setTip: CART.SET_TIP,
			}),
			displayTip(size) {
				const tipAmount = this.tips[size];
				const formatted = Formatter.centsToDollars(tipAmount);
				return `$${formatted}`;
			},
			smallTip() {
				return this.displayTip('small');
			},
			mediumTip() {
				return this.displayTip('medium');
			},
			largeTip() {
				return this.displayTip('large');
			},
			getTipAmount(percent) {
				return Math.round(this.price * percent)
			},
			calculateTips() {
				if (this.abovePriceBoundary) {
					this.tips.small = this.getTipAmount(0.10);
					this.tips.medium = this.getTipAmount(0.15);
					this.tips.large = this.getTipAmount(0.20);
				}
			},
			closeModal() {
				this.$modal.hide('contentModal');
			},
			handleTipClick(size) {
				const tip = this.tips[size];
				this.setTip(tip);
				this.closeModal();
			}
		},
		created() {
			this.calculateTips();
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.heading--info {
		margin-top: 1em;
		margin-bottom: 1rem;

		color: $storeOptionTextColor;

		font-size: 1.3rem;
		font-weight: bold;
		text-align: center;
	}
	.tip-options {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tip-container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		margin: auto;
		border-radius: 6px;
		
		cursor: pointer;

		.tip-card {
			display: flex;
			position: relative;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border-radius: 6px;

			margin: 0.75rem;
			
			width: 8rem;
			height: 8rem;
			
			background-color: $greyBackground;
			box-shadow: 1px 1px 3px lightgrey;

			cursor: pointer;

			.tip-emoji {
				font-size: 3.5rem;
			}
			span {
				font-weight: bold;
				font-size: 1.3rem;
			}
			.tip--actual-amount {
				position: absolute;
				bottom: -2rem;

				font-size: 0.8rem;
			}
		}
	}
	.tip--amount {
		position: relative;
		font-weight: bold;
	}
	@include desktop {
		.tip-card {
			&:hover {
				background-color: $offerHighlight;
			}
			&:active {
				background-color: $shadow;
			}
		}
	}
	@include mobile {
		.tip-container {
			padding: 1rem;
			
			width: 100%;

			.tip-card {
				margin: 0.25rem;

				width: 5rem;
				height: 5rem;

				.tip-emoji {
					font-size: 2rem;
				}
				span {
					font-weight: bold;
					font-size: 12pt;
				}
			}

			.tip-options {
				max-width: 90vw;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/Tips.vue